import React from 'react'
import VerifiedUserSharpIcon from '@material-ui/icons/VerifiedUserSharp';
import "../../../components/layout/style.css"
import Layout from '../../../components/layout';

function EmailVerified() {
    return (
        <Layout>
            <VerifiedUserSharpIcon style={{color: 'green', fontSize: '100px'}} />
            <Layout.Title>Your email has been verified <br /> successfully</Layout.Title>
            <Layout.Paragraph>Thank you</Layout.Paragraph>
        </Layout>
    )
}

export default EmailVerified

